// extracted by mini-css-extract-plugin
module.exports = {"Component":"StepPolicy_Component__3WIkb","FormAction":"StepPolicy_FormAction__lWjui"};